import React from 'react';
import { Section } from '@/pages/LandingComplete';
import SectionHeader from './SectionHeader';
import { Card, CardContent } from '@/components/ui/card';
import { Clock } from 'lucide-react';

interface TimesContent {
  title?: string;
  titleHighlight?: string;
  subtitle?: string;
  slots?: Array<{
    day: string;
    time: string;
  }>;
  note?: string;
}

export function DynamicTimes({ content }: { content: TimesContent }) {
  const slots = content.slots || [];

  return (
    <Section id="zeiten" alternate>
      <SectionHeader
        number="04"
        title={content.title || "Arbeitszeiten &"}
        highlight={content.titleHighlight || "Verfügbarkeit"}
        centered={false}
      />

      <div className="grid items-center gap-16 lg:grid-cols-2">
        <div>
          {content.subtitle && (
            <p className="text-xl text-muted-foreground leading-relaxed mb-8">
              {content.subtitle}
            </p>
          )}

          <div className="space-y-4">
            {slots.map((slot, i) => (
              <div key={i} className="flex items-start gap-4 p-5 rounded-2xl bg-card border border-navy/10 shadow-soft transition-all hover:shadow-lift hover:border-primary/30">
                <div className="p-2.5 rounded-full bg-primary/10">
                  <Clock size={18} className="text-primary" />
                </div>
                <span className="text-foreground/85 leading-relaxed font-medium">
                  <strong className="text-navy">{slot.day}:</strong> {slot.time}
                </span>
              </div>
            ))}
          </div>

          {content.note && (
            <p className="mt-6 text-muted-foreground italic">{content.note}</p>
          )}
        </div>

        <div className="relative">
          <div className="absolute -top-8 -right-8 w-64 h-64 bg-gradient-to-br from-accent/15 to-flame/10 rounded-full blur-3xl" aria-hidden="true"></div>

          {/* Leiterbahn-Rahmen */}
          <div className="absolute -bottom-5 -left-5 w-full h-full rounded-[2rem] border-2 border-primary/20 pointer-events-none" aria-hidden="true">
            <span className="absolute -bottom-[7px] right-12 h-3 w-3 rounded-full border-2 border-primary/50 bg-background" />
          </div>

          <Card className="overflow-hidden border border-navy/10 shadow-lift rounded-[2rem] relative z-10">
            <CardContent className="p-0 relative">
              <div className="absolute top-6 right-6 z-10">
                <div className="bg-background/90 backdrop-blur-sm rounded-full px-4 py-2 shadow-soft border border-border">
                  <div className="flex items-center gap-2 text-sm font-bold text-navy">
                    <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                    Mo-Fr 8:00-17:00
                  </div>
                </div>
              </div>
              <img
                src="https://images.unsplash.com/photo-1573164713714-d95e436ab8d6"
                alt="Remote Support Arbeitsplatz"
                loading="lazy"
                className="h-96 w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/40 via-transparent to-transparent"></div>
            </CardContent>
          </Card>
        </div>
      </div>
    </Section>
  );
}
